import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TableUtils from '../../../../../utils/TableUtils';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import CaptchaModal from '../../../../../utils/CaptchaModal';
import Session from "../../../../../utils/Session";
import {
    RESULTS_PER_PAGE
}
from '../../../../../config';


class ResultadoBusqueda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        datos: this.procesarDatos(props.datos),
        times: Session.getAccessTimes()
    };

    this.checker = null;
    this.setCheckerRef = element => {
        this.checker = element;
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      datos: this.procesarDatos(nextProps.datos)
    });
  }

  procesarDatos(datos) {
    return datos;
  }

  apellidoNombreFormat = (cell, row) => {
    return `${row.apellido} ${row.nombre}`;
  }

  onRowClick = (row) => {
    /*  this.checker.setTarget(row);
      if (!this.checkMaxTimes()) {
          return;
      }

      this.setState({
          times: Session.incAccessTimes()
      });*/

      //decidir que hacemos aca, lifteamos el estado o disparo evento...
      // ese true es para que sepa que es una persona porque tiene la logica de la busqueda full
      this.props.onResultadoSeleccionado(row.cuil, true);
  }

    goToDetail = () => {
        if (!this.checker.getTarget()) {
            return;
        }

        this.setState({
            times: Session.incAccessTimes()
        });

        let cuil = this.checker.getTarget().cuil;
        this.props.onResultadoSeleccionado(cuil, true);
    };

    closeModal = () => {
        this.checker.closeModal();
    };

    checkMaxTimes = () => {
        return this.state.times < 50;
    };

  render() {
    const table_options = TableUtils.defaultConfig({ pagination: true },
      {
        onRowClick: this.onRowClick,
        onPageChange: this.props.onPageChange,
        page: this.props.currentPage,
        sizePerPage: RESULTS_PER_PAGE
      });

      function locationFormatter(cell, row) {
          return `${row.localidad}, ${row.provincia}`
      }

      return (
        <div>
          <BootstrapTable data={this.state.datos} remote={true} options={table_options}
            fetchInfo={{ dataTotalSize: this.props.totalDataSize }}
            striped={true} pagination>
            <TableHeaderColumn width="350px" dataField="nombre" dataSort={true} dataFormat={this.apellidoNombreFormat}>Apellido y Nombre</TableHeaderColumn>
            <TableHeaderColumn width="150px" dataField="cuil" isKey={true} dataSort={true}>CUIT</TableHeaderColumn>
            <TableHeaderColumn width="200px" dataField="fecha" dataFormat={TableUtils.dateFormat} dataSort={true}>Fecha de Nacimiento</TableHeaderColumn>
            <TableHeaderColumn width="250px" dataField="provincia" dataFormat={locationFormatter} dataSort={true}>Ubicación</TableHeaderColumn>
          </BootstrapTable>
        </div>
    );
  }

  static propTypes = {
    datos: PropTypes.array,
    onResultadoSeleccionado: PropTypes.func,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.number,
    totalDataSize: PropTypes.number
  }
}


export default ResultadoBusqueda;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-busqueda/components/ResultadoBusqueda.js